import { processSteps, siteConfig } from '@/mocks/data';

export default function ProcessSection() {
  const whatsappHref = `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent('Merhaba, Fineco Isı Pompası kurulum süreci hakkında bilgi almak istiyorum.')}`;

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-4">
            Bilgi Almaktan Kuruluma Kadar Süreç
          </h2>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-primary-200 -translate-y-1/2" style={{ marginLeft: '60px', marginRight: '60px' }}></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 md:gap-4">
            {processSteps.map((step, index) => (
              <div key={step.id} className="relative flex flex-col items-center text-center group">
                <div className="w-14 h-14 rounded-full bg-primary-500 flex items-center justify-center mb-4 relative z-10 group-hover:scale-110 transition-transform">
                  <span className="text-background-50 font-heading text-lg">{index + 1}</span>
                </div>
                <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mb-3 group-hover:bg-primary-200 transition-colors">
                  <i className={`${step.icon} text-primary-600 text-lg w-5 h-5 flex items-center justify-center`}></i>
                </div>
                <h3 className="font-heading text-sm text-foreground-900 mb-2">{step.title}</h3>
                <p className="text-foreground-600 text-xs leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="flex justify-center mt-12">
          <a
            href={whatsappHref}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-6 py-3 rounded-md text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-whatsapp-line w-5 h-5 flex items-center justify-center"></i>
            Hemen Süreci Başlat
          </a>
        </div>
      </div>
    </section>
  );
}